// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../node_modules/rescript/lib/es6/caml_option.js";
import * as NavSDK$Showside from "./utils/NavSDK.bs.js";
import * as Location$Showside from "./utils/Location.bs.js";
import * as AltFunnel$Showside from "./utils/AltFunnel.bs.js";
import * as Caml_js_exceptions from "../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as InlineApp$Showside from "./apps/InlineApp.bs.js";
import * as EmbedTypes$Showside from "./types/EmbedTypes.bs.js";
import * as Slider_Lazy$Showside from "./utils/Slider_Lazy.bs.js";
import * as Webapi__Dom__Element from "../../../node_modules/rescript-webapi/lib/es6_global/src/Webapi/Dom/Webapi__Dom__Element.bs.js";
import * as ErrorBoundary$Showside from "./utils/ErrorBoundary.bs.js";
import * as ReactDOMUtils$Showside from "./utils/ReactDOMUtils.bs.js";
import * as ConfigIdGetter$Showside from "./ConfigIdGetter.bs.js";
import * as LocationConfig$Showside from "./utils/LocationConfig.bs.js";
import * as RouterProvider$Showside from "./context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "./context/ViewportContext.bs.js";
import * as ShopifyAnalytics$Showside from "./utils/ShopifyAnalytics.bs.js";
import * as CriticalCSSProvider$Showside from "./context/CriticalCSSProvider.bs.js";
import * as ConfigurationProvider$Showside from "./context/ConfigurationProvider.bs.js";
import * as ExternalIntegrationProvider$Showside from "./context/ExternalIntegrationProvider.bs.js";
import * as PictureInPicture2SessionStorage$Showside from "./utils/PictureInPicture2SessionStorage.bs.js";
function getElements(param) {
  return Belt_Array.map(Belt_Array.keepMap(Belt_Array.map(Array.prototype.slice.call(document.querySelectorAll("#maker-smartnav-inline")), Webapi__Dom__Element.ofNode), function (node) {
    return node;
  }), AltFunnel$Showside.setupAltFunnelElement);
}
function InlineEntrypoint$InlineEntrypoint(Props) {
  var configId = Props.configId;
  var embedTypeOpt = Props.embedType;
  var attributes = Props.attributes;
  var element = Props.element;
  var trackers = Props.trackers;
  var onAddToCart = Props.onAddToCart;
  var onOpenLink = Props.onOpenLink;
  var embedType = embedTypeOpt !== undefined ? embedTypeOpt : /* Inline */1;
  var attributes$1 = EmbedTypes$Showside.Attributes.useAttributesObserver(element, attributes);
  var namespace = EmbedTypes$Showside.getNamespace(attributes$1);
  var accountId = Belt_Option.flatMap(attributes$1, function (attr) {
    return attr.account;
  });
  React.useEffect(function () {
    if (!ShopifyAnalytics$Showside.isProductPage(undefined)) {
      PictureInPicture2SessionStorage$Showside.clearLastCategory(undefined);
    }
  }, []);
  React.useEffect(function () {
    return Curry._1(Slider_Lazy$Showside.preload, undefined);
  }, []);
  React.useEffect(function () {
    var $$event = new Event("maker-smartnav-inline-rendered");
    document.dispatchEvent($$event);
  });
  var tmp = {
    configId: configId,
    embedType: embedType
  };
  if (attributes$1 !== undefined) {
    tmp.attributes = Caml_option.valFromOption(attributes$1);
  }
  var tmp$1 = {
    children: React.createElement(CriticalCSSProvider$Showside.make, CriticalCSSProvider$Showside.makeProps(React.createElement(ExternalIntegrationProvider$Showside.make, {
      value: {
        accountId: accountId,
        trackers: trackers,
        onAddToCart: onAddToCart,
        onOpenLink: onOpenLink
      },
      children: React.createElement(ViewportContext$Showside.Provider.make, {
        children: React.createElement(RouterProvider$Showside.make, {
          configId: configId,
          defaultInitialRoute: {
            TAG: /* Home */0,
            _0: {
              homeType: /* Index */0,
              filters: undefined,
              sort: undefined
            }
          },
          embedType: embedType,
          children: React.createElement(ConfigurationProvider$Showside.make, {
            configId: configId,
            children: React.createElement(NavSDK$Showside.Provider.make, {
              children: React.createElement(InlineApp$Showside.make, tmp)
            }),
            enableTrimmingTreeByReferrer: true
          })
        })
      })
    }), undefined, undefined))
  };
  if (namespace !== undefined) {
    tmp$1.namespace = Caml_option.valFromOption(namespace);
  }
  return React.createElement(React.StrictMode, {
    children: React.createElement(LocationConfig$Showside.Provider.make, tmp$1)
  });
}
InlineEntrypoint$InlineEntrypoint.displayName = "InlineEntrypoint.InlineEntrypoint";
var InlineEntrypoint = {
  make: InlineEntrypoint$InlineEntrypoint
};
function render(configId, onOpenLink, onAddToCart, trackers, isLauncher, element, attributes) {
  var elementId = element.id;
  var newDictEntry = [[elementId, element]];
  var attributes$1 = Belt_Option.map(attributes, function (attr) {
    return attr.attributes;
  });
  try {
    Belt_Option.forEach(window.smartNavElementsInline, function (smartNavElements) {
      Belt_Option.forEach(Js_dict.get(smartNavElements, elementId), ReactDOMUtils$Showside.unmountComponentAtNode);
    });
  } catch (raw_e) {
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    console.error("unable to unmount smartNavElementInline", e);
  }
  window.smartNavElementsInline = Belt_Option.mapWithDefault(window.smartNavElementsInline, Js_dict.fromArray(newDictEntry), function (elements) {
    return Js_dict.fromArray(Belt_Array.concat(Js_dict.entries(elements), newDictEntry));
  });
  element.setAttribute("data-maker-smartnav-inline", "true");
  var tmp = {
    configId: configId,
    element: element,
    key: configId
  };
  if (attributes$1 !== undefined) {
    tmp.attributes = Caml_option.valFromOption(attributes$1);
  }
  if (trackers !== undefined) {
    tmp.trackers = Caml_option.valFromOption(trackers);
  }
  if (onAddToCart !== undefined) {
    tmp.onAddToCart = Caml_option.valFromOption(onAddToCart);
  }
  if (onOpenLink !== undefined) {
    tmp.onOpenLink = Caml_option.valFromOption(onOpenLink);
  }
  ReactDOMUtils$Showside.render(React.createElement(React.Fragment, undefined, React.createElement(ErrorBoundary$Showside.make, {
    componentName: "Root",
    children: React.createElement(InlineEntrypoint$InlineEntrypoint, tmp)
  })), element);
}
function goTo(quickView, quickNav, replaceState, preserveScroll, namespace) {
  Location$Showside.goTo(namespace, undefined, quickView, quickNav, replaceState, preserveScroll, undefined);
}
async function initSmartnav(index, element) {
  EmbedTypes$Showside.Attributes.autoAssignNamespaces(undefined);
  var attributes = EmbedTypes$Showside.Attributes.fromElement(element);
  var configId = await ConfigIdGetter$Showside.getConfigId(undefined, undefined, undefined, attributes, /* Inline */1);
  if (configId !== undefined) {
    return render(configId, undefined, undefined, undefined, false, element, {
      embedType: /* Inline */1,
      attributes: attributes
    });
  }
}
function init(param) {
  var elements = getElements(undefined);
  if (elements.length !== 0) {
    return Belt_Array.forEachWithIndex(elements, function (index, element) {
      initSmartnav(index, element);
    });
  } else {
    console.error("Could not initialize SmartNav: no element found");
    return;
  }
}
export { getElements, InlineEntrypoint, render, goTo, initSmartnav, init };
/* react Not a pure module */